import Vue from 'vue'
Vue.filter('decimal', (value, suffix = '', prefix = '', language = 'pt-BR') => {
  if (value !== undefined) {
    if (!isNaN(parseFloat(value)) && isFinite(value)) {
      if (prefix && suffix) {
        return `${prefix} ${parseFloat(value).toLocaleString(language, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'decimal' })} ${suffix}`
      } else if (prefix) {
        return `${prefix} ${parseFloat(value).toLocaleString(language, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'decimal' })}`
      } else if (suffix) {
        return `${parseFloat(value).toLocaleString(language, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'decimal' })} ${suffix}`
      } else {
        return parseFloat(value).toLocaleString(language, { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'decimal' })
      }
    } else {
      return value
    }
  }
})
